// Utility functions for promotion status
export const getPromotionStatus = (promotion: any) => {
  const now = new Date()
  const startDate = new Date(promotion.startDateTime)
  const finishDate = new Date(promotion.finishDateTime)
  
  // Check if disabled
  if (!promotion.isActive) {
    return { label: 'Deaktif', color: 'secondary', icon: '⭕' }
  }
  
  // Check if expired
  if (finishDate < now) {
    return { label: 'Süresi Geçmiş', color: 'warning', icon: '⏱️' }
  }
  
  // Check if exhausted
  if (promotion.usageLimit !== null && promotion.usageLimit !== undefined) {
    if (promotion.usedCount >= promotion.usageLimit) {
      return { label: 'Tükenmiş', color: 'danger', icon: '🚫' }
    }
  }
  
  // Check if not started
  if (startDate > now) {
    return { label: 'Başlamadı', color: 'info', icon: '⏳' }
  }
  
  // Active
  return { label: 'Aktif', color: 'success', icon: '✓' }
}

export const getUsageInfo = (promotion: any) => {
  if (promotion.usageLimit === null || promotion.usageLimit === undefined) {
    return `${promotion.usedCount || 0} / Sınırsız`
  }
  return `${promotion.usedCount || 0} / ${promotion.usageLimit}`
}
